import PropTypes from 'prop-types';
import MKBox from 'components/MaterialKit/MKBox';
import MKTypography from 'components/MaterialKit/MKTypography';
import { initialAuthState, useAuth } from 'contexts/auth';
import { useCallback, useEffect, useState } from 'react';
import { getLocaleMap } from 'utils/locales';
import Button from 'components/Button';
import { logout } from 'api/auth';
import { useNavigate } from 'react-router-dom';
import { handleErrorResponse } from 'utils/general';

const DEFAULT_MENU_HEADER_HEIGHT = 100;

const WatchOnePageHeaderSection = ({ bg_color, text_color, text_size, button_color, button_border_radius, button_border_color, button_border_width, show_display_name, show_button, ...props }) => {
  const { auth, setAuth } = useAuth();
  const navigate = useNavigate();
  const [lm, setLm] = useState({});
  useEffect(() => {
    getLocaleMap(['logout'])
      .then((response) => {
        setLm(response);
      });
  }, []);

  const handleLogout = useCallback(() => {
    return logout()
      .then(() => {
        setAuth(initialAuthState);
        navigate('/login');
      })
      .catch((err) => {
        handleErrorResponse(err, setAuth);
      });
  }, [navigate, setAuth]);

  return (
    <MKBox
      display="flex"
      justifyContent="flex-end"
      alignItems="center"
      p={{ xs: 0, md: 2 }}
      bgColor={bg_color}
      sx={{ height: DEFAULT_MENU_HEADER_HEIGHT }}
    >
      {show_display_name && (
        <MKTypography mr={3} color={text_color} fontSize={text_size}>
          {auth?.user?.display_name}
        </MKTypography>
      )}
      <Button onClick={handleLogout} color={button_color} borderRadius={button_border_radius} style={{ border: `${button_border_width} solid ${button_border_color}`, padding: '5px 30px' }}>
        <MKTypography color={text_color} fontSize={text_size}>
          {lm.logout}
        </MKTypography>
      </Button>
    </MKBox>
  );
};

WatchOnePageHeaderSection.propTypes = {
  bg_color: PropTypes.string,
  text_color: PropTypes.string,
  text_size: PropTypes.string,
  button_color: PropTypes.string,
  button_border_radius: PropTypes.string,
  button_border_color: PropTypes.string,
  button_border_width: PropTypes.string,
  show_display_name: PropTypes.bool,
  show_button: PropTypes.bool,
};

WatchOnePageHeaderSection.defaultProps = {
  bg_color: '#2c589d',
  text_color: 'white',
  text_size: '18px',
  button_color: '#2c589d',
  button_border_radius: '0px',
  button_border_color: 'black',
  button_border_width: '2px',
  show_display_name: true,
  show_button: true,
};

export default WatchOnePageHeaderSection;
